import React, { memo, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import Router from "app/routers/Router";
import "app/localization/localization";
import { UserProvider } from "app/store/contexts/userContext";
import { UserViewProvider } from "app/store/contexts/userContextView";
import { LanguageProvider } from "app/store/contexts/languageContext";
import { CountriesProvider } from "app/store/contexts/countriesContext";
import Loading from "app/components/Loading/Loading";
import languages from "app/localization/languages.json";
import allCountries from "app/localization/geo-countries.json";
import "./index.scss";

const App = memo(() => {
  return (
    <Suspense fallback={<Loading isFullscreen />}>
      <CountriesProvider countries={allCountries}>
        <LanguageProvider availableLanguages={languages}>
          <UserProvider>
            <UserViewProvider>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </UserViewProvider>
          </UserProvider>
        </LanguageProvider>
      </CountriesProvider>
    </Suspense>
  );
});

const rootElement = document.getElementById("root");

if (!rootElement) throw new Error("Couldn't find element with id root");

const root = createRoot(rootElement);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
